<template>
  <div>
    <div class="row">
      <div :class="['col_12', { loading_overlay: loading }]">
        <div class="card no_border">
          <div class="card-header">
            <div class="d_flex_btwn form_action_btn width_full">
              <div class="d_flex_start col_2 pl_0">
                <div class="card-title">{{ title }}</div>
              </div>
              <div class="d_flex_end col_10 pr_0">
                <div class="form_checkbox">
                  <input
                    type="checkbox"
                    id="assessment"
                    v-model="form.assessment_exam"
                  />
                  <label for="assessment">배치고사</label>
                </div>
                <div
                  :class="[
                    'form-group mb_0',
                    { has_error: errorFor('assessment_grade_id') },
                  ]"
                  v-if="form.assessment_exam"
                >
                  <select
                    v-model="form.assessment_grade_id"
                    class="form_global custom_height"
                  >
                    <option value="">{{ $t('common.select_grade') }}</option>
                    <option
                      :value="item.id"
                      v-for="item in grades"
                      :key="'grade ' + item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <router-link
                  class="btn btn_blue ml_10"
                  :to="{ name: 'exam_management_exams' }"
                  >{{ $t('common.back') }}</router-link
                >
              </div>
            </div>
          </div>
          <div :class="['card-body']">
            <div class="row">
              <!-- <div class="col_3">
                <div :class="['form-group', {'has_error': errorFor('lecture_id')}]">
                  <label>{{ $t('sidebar.exams.lecture') }}</label>
                  <select v-model="form.lecture_id" class="form_global">
                    <option value="">{{ $t('sidebar.exams.select_lecture') }}</option>
                    <option :value="lecture.id" v-for="lecture in lectures" :key="'lecture '+lecture.id">{{ lecture.video_name }}</option>
                  </select>
                  <v-errors :errors="errorFor('lecture_id')" />
                </div>
              </div> -->
              <div class="col_3">
                <div :class="['form-group', { has_error: errorFor('title') }]">
                  <label>{{ $t('common.title') }} </label>
                  <input type="text" class="form_global" v-model="form.title" />
                  <v-errors :errors="errorFor('title')" />
                </div>
              </div>

              <!-- <div class="col_3">
                <div :class="['form-group', {'has_error': errorFor('exam_type_id')}]">
                  <label>{{ $t('sidebar.exam_type.exam_type') }}</label>
                  <select v-model="form.exam_type_id" class="form_global">
                    <option value="">{{ $t('sidebar.exams.select_exam_type') }}</option>
                    <option :value="examType.id" v-for="examType in examTypes" :key="'examType '+examType.id">{{ examType.name }}</option>
                  </select>
                  <v-errors :errors="errorFor('exam_type_id')" />
                </div>
              </div> -->

              <div class="col_3">
                <div
                  :class="['form-group', { has_error: errorFor('subject_id') }]"
                >
                  <label>{{ $t('common.subject') }}</label>
                  <select v-model="form.subject_id" class="form_global">
                    <option value="">{{ $t('common.select_subject') }}</option>
                    <option
                      :value="subject.id"
                      v-for="subject in subjects"
                      :key="'subject ' + subject.id"
                    >
                      {{ subject.name }}
                    </option>
                  </select>
                  <v-errors :errors="errorFor('subject_id')" />
                </div>
              </div>

              <div class="col_3">
                <div
                  :class="['form-group', { has_error: errorFor('area_id') }]"
                >
                  <label>{{ $t('common.area') }}</label>
                  <select v-model="form.area_id" class="form_global">
                    <option value="">{{ $t('common.select_area') }}</option>
                    <option
                      :value="area.id"
                      v-for="area in areas"
                      :key="'area ' + area.id"
                    >
                      {{ area.name }}
                    </option>
                  </select>
                  <v-errors :errors="errorFor('area_id')" />
                </div>
              </div>

              <div class="col_3">
                <div
                  :class="['form-group', { has_error: errorFor('grade_id') }]"
                >
                  <label>{{ $t('common.grade') }}</label>
                  <select
                    v-model="form.grade_id"
                    class="form_global"
                    @change="loadUnitData()"
                  >
                    <option value="">{{ $t('common.select_grade') }}</option>
                    <option
                      :value="item.id"
                      v-for="item in grades"
                      :key="'grade ' + item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                  <v-errors :errors="errorFor('grade_id')" />
                </div>
              </div>

              <div class="col_3">
                <div
                  :class="[
                    'form-group',
                    { has_error: errorFor('semester_id') },
                  ]"
                >
                  <label>{{ $t('sidebar.semesters.semesters') }}</label>
                  <select
                    v-model="form.semester_id"
                    class="form_global"
                    @change="loadUnitData()"
                  >
                    <option value="">{{ $t('common.select_semester') }}</option>
                    <option
                      :value="item.id"
                      v-for="item in semesters"
                      :key="'semester_id ' + item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                  <v-errors :errors="errorFor('semester_id')" />
                </div>
              </div>

              <div class="col_3">
                <div
                  :class="['form-group', { has_error: errorFor('unit_id') }]"
                >
                  <label>{{ $t('common.unit') }}</label>
                  <select
                    v-model="form.unit_id"
                    class="form_global"
                    @change="unitsChange()"
                  >
                    <option value="">{{ $t('common.select_unit') }}</option>
                    <!-- <option :value="item.id" v-for="item in units" :key="'unit_id '+item.id">{{ item.unit_name }} {{ item && item.unit_goal ? '- ' + unitGoal(item.unit_goal,40) : ''}}</option> -->
                    <option
                      :value="item.id"
                      v-for="item in units"
                      :key="'unit_id ' + item.id"
                    >
                      {{ item.unit_name }}
                    </option>
                  </select>
                  <v-errors :errors="errorFor('unit_id')" />
                </div>
              </div>

              <div class="col_3">
                <div
                  :class="[
                    'form-group',
                    { has_error: errorFor('car_time_id') },
                  ]"
                >
                  <label>{{ $t('sidebar.unitManagement.car_city') }}</label>
                  <select v-model="form.car_time_id" class="form_global">
                    <option value="">
                      {{ $t('common.select') }}
                      {{ $t('sidebar.unitManagement.car_city') }}
                    </option>
                    <option
                      :value="item.id"
                      v-for="item in cities"
                      :key="'car_time_id ' + item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                  <v-errors :errors="errorFor('car_time_id')" />
                </div>
              </div>

              <div class="col_3">
                <div
                  :class="['form-group', { has_error: errorFor('exam_time') }]"
                >
                  <label>{{ $t('sidebar.exams.exam_time') }} </label>
                  <input
                    type="number"
                    class="form_global"
                    placeholder="minute"
                    v-model="form.exam_time"
                    min="1"
                  />
                  <v-errors :errors="errorFor('exam_time')" />
                </div>
              </div>

              <div class="col_3">
                <div
                  :class="[
                    'form-group',
                    { has_error: errorFor('notation_name') },
                  ]"
                >
                  <label>{{ $t('sidebar.exams.notation_name') }} </label>
                  <input
                    type="text"
                    class="form_global"
                    v-model="form.notation_name"
                  />
                  <v-errors :errors="errorFor('notation_name')" />
                </div>
              </div>

              <div class="col_3">
                <div :class="['form-group', { has_error: errorFor('status') }]">
                  <label>{{ $t('common.status') }}</label>
                  <div class="form_inline">
                    <div class="form_radio">
                      <input
                        type="radio"
                        id="active"
                        value="1"
                        v-model="form.status"
                      />
                      <label for="active">{{ $t('common.active') }}</label>
                    </div>
                    <div class="form_radio">
                      <input
                        type="radio"
                        id="inactive"
                        value="0"
                        v-model="form.status"
                      />
                      <label for="inactive">{{ $t('common.inactive') }}</label>
                    </div>
                  </div>
                  <v-errors :errors="errorFor('status')" />
                </div>
              </div>
              <div class="col_3">
                <div
                  :class="['form-group', { has_error: errorFor('parking_id') }]"
                >
                  <label>{{ $t('common.parking') }}</label>
                  <select v-model="form.parking_id" class="form_global">
                    <option value="">{{ $t('common.select_parking') }}</option>
                    <option
                      :value="parking.id"
                      v-for="parking in parkings"
                      :key="'parking ' + parking.id"
                    >
                      {{ parking.name }}
                    </option>
                  </select>
                  <v-errors :errors="errorFor('parking_id')" />
                </div>
              </div>
              <div class="col_3">
                <div :class="['form-group', { has_error: errorFor('scope') }]">
                  <label>{{ $t('sidebar.unitManagement.scope') }}</label>
                  <select class="form_global" id="scope" v-model="form.scope">
                    <option value="">{{ $t('common.select') }}</option>
                    <option value="one">*</option>
                    <option value="two">**</option>
                    <option value="three">***</option>
                    <option value="four">****</option>
                    <option value="five">*****</option>
                  </select>
                  <v-errors :errors="errorFor('scope')" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col_6">
                <div
                  :class="[
                    'form-group',
                    { has_error: errorFor('learning_objectives') },
                  ]"
                >
                  <label>{{ $t('sidebar.exams.learning_objectives') }}</label>
                  <text-editor-component
                    :id="'learning_objectives'"
                    :existingData="
                      form.learning_objectives ? form.learning_objectives : ''
                    "
                    @change="changeEditorValue"
                  />
                  <v-errors :errors="errorFor('learning_objectives')" />
                </div>
              </div>
              <div class="col_6">
                <div
                  :class="['form-group', { has_error: errorFor('test_range') }]"
                >
                  <label>{{ $t('sidebar.exams.test_range') }}</label>
                  <text-editor-component
                    :id="'test_range'"
                    :existingData="form.test_range ? form.test_range : ''"
                    @change="changeEditorValue"
                  />
                  <v-errors :errors="errorFor('test_range')" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col_6">
                <div
                  :class="[
                    'form-group',
                    { has_error: errorFor('learning_guide') },
                  ]"
                >
                  <label>{{ $t('sidebar.exams.learning_guide') }}</label>
                  <text-editor-component
                    :id="'learning_guide'"
                    :existingData="
                      form.learning_guide ? form.learning_guide : ''
                    "
                    @change="changeEditorValue"
                  />
                  <v-errors :errors="errorFor('learning_guide')" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="d_flex_start mt_20 mb_20">
                <h4>{{ $t('sidebar.questions.question_list') }}</h4>
              </div>
              <div class="table_responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th class="align_left">{{ $t('common.title') }}</th>
                      <th>{{ $t('common.grade') }}</th>
                      <th>{{ $t('common.semester') }}</th>
                      <th>{{ $t('common.unit') }}</th>
                      <th class="width_200p">{{ $t('sidebar.exams.type') }}</th>
                      <th class="width_200p">
                        {{ $t('sidebar.exams.order') }}
                      </th>
                      <th class="width_200p">
                        {{ $t('sidebar.questions.admin_note') }}
                      </th>
                      <th class="width_200p">{{ $t('common.action') }}</th>
                    </tr>
                  </thead>
                  <tbody v-if="selectedQuestionList.length">
                    <draggable
                      v-model="selectedQuestionList"
                      :list="selectedQuestionList"
                      :disabled="!enabled"
                      group="people"
                      item-key="id"
                      style="display: contents"
                      @start="dragging = true"
                      @end="onDragEnd"
                    >
                      <template #item="{ element, index }">
                        <tr>
                          <td class="overflow_hidden question_title align_left">
                            <div
                              class="text_shorten"
                              v-html="convertTextEditor(element.title)"
                              v-if="element && element.title"
                            ></div>
                          </td>
                          <td>
                            <span v-if="element && element.grade_id">
                              {{
                                grades.length
                                  ? grades.find(
                                      (s) => s.id == parseInt(element.grade_id)
                                    )
                                    ? grades.find(
                                        (s) =>
                                          s.id == parseInt(element.grade_id)
                                      ).name
                                    : ''
                                  : ''
                              }}
                            </span>
                          </td>
                          <td>
                            <span v-if="element && element.semester_id">
                              {{
                                semesters.length
                                  ? semesters.find(
                                      (s) =>
                                        s.id == parseInt(element.semester_id)
                                    )
                                    ? semesters.find(
                                        (s) =>
                                          s.id == parseInt(element.semester_id)
                                      ).name
                                    : ''
                                  : ''
                              }}
                            </span>
                          </td>
                          <td>
                            <span v-if="element && element.unit_id">
                              {{
                                units.length
                                  ? units.find(
                                      (s) => s.id == parseInt(element.unit_id)
                                    )
                                    ? units.find(
                                        (s) => s.id == parseInt(element.unit_id)
                                      ).unit_name
                                    : ''
                                  : ''
                              }}
                            </span>
                          </td>
                          <td class="width_200p">
                            {{
                              element?.question_type === 'multiple-choice'
                                ? $t('sidebar.questions.multiple_choice')
                                : element?.question_type === 'short-answer'
                                ? $t('sidebar.questions.short_answer')
                                : $t('sidebar.questions.descriptive')
                            }}
                          </td>
                          <td>{{ index + 1 }}</td>
                          <td class="width_200p">
                            <div
                              v-html="convertTextEditor(element.admin_note)"
                              v-if="element && element.admin_note"
                            ></div>
                          </td>
                          <td>
                            <button
                              class="btn btn_blue ml_10 question_remove"
                              @click="removeQuestion(element.id)"
                            >
                              <img
                                :src="`${baseUrl}assets/media/images/icon/9.png`"
                                alt=""
                              />
                            </button>
                          </td>
                        </tr>
                      </template>
                    </draggable>
                  </tbody>

                  <tbody v-else>
                    <tr>
                      <td colspan="7">{{ $t('common.no_data_msg') }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="d_flex_end mt_20">
              <button
                class="btn btn_md btn_common"
                @click.prevent="questionModal()"
              >
                {{ $t('sidebar.questions.questions') }}
              </button>
              <button
                class="btn btn_md btn_blue ml_20"
                @click.prevent="submit()"
              >
                {{ $t('common.save') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <question-modal
      v-if="openQuestionModal"
      :openQuestionModal="openQuestionModal"
      :unit_id="form.unit_id"
      :grade_id="form.grade_id"
      :semester_id="form.semester_id"
      @questionData="questionData"
      :selectedQuestions="selectedQuestions"
      @closeQuestionModal="closeQuestionModal"
    >
    </question-modal>
  </div>
</template>

<script>
import TextEditorComponent from '@/components/TextEditorComponent';
import QuestionModal from './QuestionModal';
import Mathml2latex from 'mathml-to-latex';
import draggable from 'vuedraggable';

export default {
  components: { QuestionModal, TextEditorComponent, draggable },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
      title: this.$t('sidebar.exams.add_exam'),
      lectures: [],
      // examTypes: [],
      subjects: [],
      areas: [],
      semesters: [],
      grades: [],
      units: [],
      cities: [],
      parkings: [],
      form: {
        assessment_exam: false,
        assessment_grade_id: '',
        lecture_id: '',
        subject_id: '',
        area_id: '',
        grade_id: '',
        semester_id: '',
        unit_id: '',
        car_time_id: '',
        notation_name: '',
        status: 1,
        // exam_type_id: '',
        exam_time: '',
        title: '',
        learning_objectives: '',
        test_range: '',
        learning_guide: '',
        parking_id: '',
        scope: '',
        questions: [],
      },
      selectedQuestions: [],
      selectedQuestionList: [],
      openQuestionModal: false,
      dragging: false,
      enabled: true,
    };
  },
  updated() {
    this.$nextTick().then(() => {
      if (window.MathJax) {
        window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub]);
      }
    });
  },
  created() {
    this.$nextTick().then(() => {
      if (window.MathJax) {
        window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub]);
      }
    });

    this.axios
      .get('/lectures')
      .then((response) => (this.lectures = response.data.data));
    // this.axios.get('/exam-types').then((response) => this.examTypes = response.data.data);
    this.axios
      .get('/subjects')
      .then((response) => (this.subjects = response.data.data));
    this.axios
      .get('/areas')
      .then((response) => (this.areas = response.data.data));
    this.axios
      .get('/grades')
      .then((response) => (this.grades = response.data.data));
    this.axios
      .get('/semesters')
      .then((response) => (this.semesters = response.data.data));
    // this.axios.get('/units').then((response) => this.units = response.data.data);
    this.axios
      .get('/parkings')
      .then((response) => (this.parkings = response.data.data));

    if (this.$route.name === 'exam_management_exam_edit') {
      this.axios.get('/exams/' + this.$route.params.id).then((response) => {
        let examData = response.data.data;

        let carCityUnit = examData.unit;

        if (carCityUnit) {
          this.cities =
            carCityUnit.carcity && carCityUnit.carcity.length
              ? carCityUnit.carcity
              : [];
        }

        this.form.lecture_id = examData.lecture ? examData.lecture.id : '';
        this.form.notation_name = examData.notation_name;
        this.form.status = examData.status;
        // this.form.exam_type_id = examData.examType ? examData.examType.id : '';
        this.form.exam_time = examData.exam_time;
        this.form.title = examData.title;
        this.form.learning_objectives = examData.learning_objectives;
        this.form.test_range = examData.test_range;
        this.form.learning_guide = examData.learning_guide;
        this.form.subject_id = examData.subject ? examData.subject.id : '';
        this.form.area_id = examData.area ? examData.area.id : '';
        this.form.grade_id = examData.grade ? examData.grade.id : '';
        this.form.assessment_grade_id = examData.assessment_grade
          ? examData.assessment_grade.id
          : '';
        this.form.semester_id = examData.semester ? examData.semester.id : '';
        this.form.unit_id = examData.unit ? examData.unit.id : '';
        this.form.car_time_id = examData.carcity ? examData.carcity.id : '';
        this.form.parking_id = examData.parking ? examData.parking.id : '';
        this.form.scope = examData.scope;
        this.form.questions = examData.questions;
        this.form.assessment_exam = examData.assessment_exam;

        this.editUnitData();

        examData.questions.forEach((element) => {
          this.selectedQuestions.push(element.question_id);
          this.selectedQuestionList.push(element.question);
        });
      });
      this.title = this.$t('sidebar.exams.edit_exam');
    }
  },
  methods: {
    updateOrderIds() {
      this.selectedQuestionList.forEach((element, order) => {
        element.order = order + 1;
      });
      this.selectedQuestionList.forEach((element) => {
        // Find the corresponding question in form.questions based on element id
        const question = this.form.questions.find(
          (q) => q.question_id === element.id
        );
        if (question) {
          // Update the sort order of the question
          question.sort = element.order;
        }
      });
    },
    onDragEnd() {
      this.updateOrderIds();
    },
    changeEditorValue(editorId, data) {
      this.form[editorId] = data;
    },
    unitsChange() {
      this.form.car_time_id = '';
      let id = this.form.unit_id;

      if (id) {
        let unit = this.units.find((i) => i.id === id);

        if (unit && unit.carcity.length) {
          this.cities = unit.carcity;
        }
      } else {
        this.cities = [];
      }
    },
    __convertTextEditor(string) {
      return string ? string.replace(/<img[^>]*>/g, '') : '';
    },
    convertTextEditor(string) {
      let parser = new DOMParser();
      const doc = parser.parseFromString(string, 'text/html');
      let mathTags = doc.getElementsByTagName('math');
      if (mathTags.length > 0) {
        [...mathTags].forEach((mathTag) => {
          mathTag.replaceWith(this.getLatex(mathTag.outerHTML));
        });
        return doc.body.innerHTML.replace(/<img[^>]*>/g, '');
      } else {
        return string ? string.replace(/<img[^>]*>/g, '') : '';
      }
    },
    getLatex(mathTag) {
      try {
        let latex = Mathml2latex.convert(mathTag);
        latex = this.sanitizeLatex(latex);
        latex = `\\[${latex}\\]`; // for block math
        return latex;
      } catch (error) {
        console.error('Latex conversion failed:', error);
        return mathTag; // fallback: keep original MathML
      }
    },
    sanitizeLatex(latex) {
      return latex
        .replace(/&nbsp;/g, ' ') // remove non-breaking spaces
        .replace(/\\left\\\(\\right\.\s*/g, '\\left(') // fix left paren
        .replace(/\s*\\left\.\s*\\right\\\)/g, '\\right)') // fix right paren
        .replace(/\s{2,}/g, ' ') // remove extra spaces
        .trim();
    },
    __getLatex(mathTag) {
      let latex = Mathml2latex.convert(mathTag);
      latex = '$$' + latex + '$$';
      latex = latex.replace(/\+\b/g, '\\\\');
      return latex;
    },
    questionModal() {
      this.openQuestionModal = true;
    },
    closeQuestionModal() {
      this.openQuestionModal = false;
    },
    questionData(data) {
      if (data.length) {
        data.forEach((item, index) => {
          let object = {
            question_id: item.id,
            status: item.status,
            sort: item.sort ?? index + 1,
          };
          let exists = this.form.questions.find(
            (q) => q.question_id === item.id
          );
          if (exists) {
            object.status = 1;
          }

          let listIndex = this.selectedQuestionList.findIndex((object) => {
            return object.id === item.id;
          });
          if (listIndex < 0) {
            this.selectedQuestionList.push(item);
          }

          let formIndex = this.form.questions.findIndex((object) => {
            return object.question_id === item.id;
          });
          if (formIndex < 0) {
            this.form.questions.push(object);
          }

          if (!this.selectedQuestions.includes(item.id)) {
            this.selectedQuestions.push(item.id);
          }
        });
        this.updateOrderIds();
      }
    },
    removeQuestion(id) {
      var index = this.selectedQuestionList.findIndex((object) => {
        return object.id == id;
      });
      if (index > -1) {
        this.selectedQuestionList.splice(index, 1);
      }

      let formQuestions = this.form.questions;
      var questionIndex = formQuestions.findIndex((object) => {
        return object.question_id === id;
      });
      if (questionIndex > -1) {
        formQuestions.splice(questionIndex, 1);
        this.selectedQuestions.splice(questionIndex, 1);
      }
      this.updateOrderIds();
    },
    submit() {
      this.allErrors = null;
      this.loading = true;

      this.form.questions = this.form.questions.filter(
        (item) => item.status === 1
      );

      if (this.$route.name === 'exam_management_exam_edit') {
        this.axios
          .patch('/exams/' + this.$route.params.id, this.form)
          .then(() => {
            this.$router.push({ name: 'exam_management_exams' });
            this.showSuccessMsg(this.$t('common.updateSuccess'));
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.axios
          .post('/exams', this.form)
          .then(() => {
            this.$router.push({ name: 'exam_management_exams' });
            this.showSuccessMsg(this.$t('common.addSuccess'));
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    loadUnitData() {
      let grade_id = this.form.grade_id;

      if (grade_id == '') {
        this.units = '';
        this.cities = '';
        this.form.unit_id = '';
        this.form.car_time_id = '';
      }

      let semester_id = this.form.semester_id;

      if (semester_id == '') {
        this.form.unit_id = '';
        this.form.car_time_id = '';
        this.units = '';
        this.cities = '';
      }

      if (grade_id && semester_id) {
        this.units = '';
        this.cities = '';
        this.form.unit_id = '';
        this.form.car_time_id = '';
        this.axios
          .post('/load-unit-data/', {
            grade_id: grade_id,
            semester_id: semester_id,
          })
          .then((response) => {
            let unitData = response.data.data;
            this.units = unitData;
            if (unitData && unitData.length < 1) {
              this.form.unit_id = '';
              this.form.car_time_id = '';
              this.units = '';
              this.cities = '';
            }
          });
      }
    },
    editUnitData() {
      let grade_id = this.form.grade_id;

      if (grade_id == '') {
        this.units = '';
        this.cities = '';
        this.form.unit_id = '';
        this.form.car_time_id = '';
      }

      let semester_id = this.form.semester_id;

      if (semester_id == '') {
        this.form.unit_id = '';
        this.form.car_time_id = '';
        this.units = '';
        this.cities = '';
      }

      if (grade_id && semester_id) {
        this.axios
          .post('/load-unit-data/', {
            grade_id: grade_id,
            semester_id: semester_id,
          })
          .then((response) => {
            let unitData = response.data.data;
            this.units = unitData;
            if (unitData && unitData.length < 1) {
              this.form.unit_id = '';
              this.form.car_time_id = '';
              this.units = '';
              this.cities = '';
            }
          });
      }
    },
    unitGoal(text, length) {
      if (text.length > length) {
        return text.substring(0, length) + '...';
      } else {
        return text;
      }
    },
  },
};
</script>

<style scoped>
.loading_overlay.small:after {
  width: 20px;
  height: 20px;
}
.question_remove {
  height: auto;
  padding: 5px 20px;
}
.question_remove img {
  width: 17px;
}
.align_left {
  text-align: left !important;
}
.custom_height {
  height: 30px !important;
  padding: 0 !important;
}
</style>
